// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer_info_note[data-v-c5dfbae6]{color:#fff;background-color:red}.customer_info_note_inner-link[data-v-c5dfbae6]{color:#fff;font-size:1.2em;text-decoration:underline}.p-address-warning[data-v-c5dfbae6]{color:#dc5353}", ""]);
// Exports
module.exports = exports;
